import * as React from "react";
import { makeIcon } from "./makeIcon";
const AddLine = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
    React.createElement("path", { d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z" })));
export const AddLineIcon = makeIcon("addLine")(AddLine);
//# sourceMappingURL=AddLine.js.map